<div
  class="d-flex justify-content-center align-items-center max-height-it-can"
  [style]="'width: ' + width + 'px; height: ' + height + 'px;'"
>
  <img
    *ngIf="width != null"
    [hidden]="loading"
    (load)="onLoad()"
    (click)="showImageDetail(src, override, defaultSource)"
    src="{{ src | imageCheck : sourceSize : override : defaultSource | async }}"
    [height]="height"
    [width]="width"
    [class]="imgClass"
  />
  <img
    *ngIf="width == null"
    [hidden]="loading"
    (load)="onLoad()"
    (click)="showImageDetail(src, override, defaultSource)"
    src="{{ src | imageCheck : sourceSize : override : defaultSource | async }}"
    [height]="height"
    width="auto"
    [class]="imgClass"
  />
  <span
    *ngIf="loading"
    class="spinner-border spinner-border-sm"
    role="status"
    aria-hidden="true"
  ></span>
</div>
